import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

import "./styles.scss";
import CustomTab from "../../../CustomTab";
import Copyright from "../../../components/Copyright";
import Header from "../components/Header";
import { AppContext } from "../../../contexts/AppContext";
import { IframeMessageProxy } from "iframe-message-proxy";
import PluginIframe from "../../../components/PluginIframe";

export default function PluginIframePage() {
    const { t } = useContext(AppContext);

    const { state } = useLocation();
    const { url } = state

    if (!url)
        return (
            <div className="flex">
                <h3>Erro na exibição do plugin</h3>
            </div>
        )

    return <div>
        <PluginIframe
            url={url}
        />
    </div>
}
